const MainTimelineSteps = [
  {
    type: "time-range",
    time_text: "2026   →  Present",
  },
  {
    break: "1",
  },
  {
    type: "time-range",
    time_text: "2025   →  2026",
  },
  {
    badge: "International Conference",
    title: "APA International Conference on Polymers for Advanced Technology",
    description:
      "Presented Poster with title - Neural Network Based Generative Method for Potential Polymer Lead Generation Targeting Oligonucleotide Polymer Conjugate",
    c_img: "./assets/images/APA-25.png",
    o_detail: {
      "Presented on": "14th October, 2025",
    },
  },
  {
    badge: "Organization",
    title: "MDAnalysis",
    description:
      "The MDAnalysis Project develops open-source tools for the analysis of molecular simulation data, providing researchers with efficient and accessible solutions for studying molecular structures and dynamics.",
    c_img: "./assets/images/mda.png",
    o_detail: {
      Position: "Code Contributor",
      "Employment Type": "Open-Source",
    },
  },
  {
    badge: "International Conference",
    title:
      "APM-2025 16th INTERNATIONAL CONFERENCE On ADVANCEMENT IN PETROCHEMICAL SECTOR & EMPOWERING SUSTAINABLE DEVELOPMENT LEADING TO “VIKSIT BHARAT” ",
    description:
      "We presented our study on aligning polymer representations within neural networks, aimed at generating potential biomedical polymers.",
    c_img: "https://www.cipetapm2025.com/assets/images/logo.png",
    o_detail: {
      "Presented on": "10th March, 2025",
    },
  },
  {
    badge: "International Conference",
    title: "The 39th Annual AAAI Conference on Artificial Intelligence",
    description:
      "In collaboration with Deep Forest Sciences and CIPET: SARP - LARPM, we presented a poster on our polymer generation algorithms at the AAAI-25 Annual Conference.",
    c_img:
      "https://aaai.org/wp-content/uploads/2024/03/AAAI-Logo-Title-White.png",
    o_detail: {
      Workshop:
        "4th Annual AAAI Workshop on AI to Accelerate Science and Engineering (AI2ASE)",
      "Presented on": "3rd March, 2025",
    },
  },
  {
    badge: "Source",
    show_links: [
      {
        text: "Know More",
        image:
          "https://aaai.org/wp-content/uploads/2023/11/AAAI-25_Mark-Inverse.png",
        url: "https://ai-2-ase.github.io/",
      },
    ],
  },
  {
    badge: "Organization",
    title: "Deep Forest Sciences",
    description:
      "Deep Forest Sciences specializes in developing toolkits for material discovery and related fields.",
    c_img: "./assets/images/dfs.png",
    o_detail: {
      Position: "Research Intern",
      "Employment Type": "Contractual",
    },
  },
  {
    badge: "Organization",
    title: "CIPET - SARP:LARPM",
    description:
      "The School for Advanced Research in Petrochemicals (SARP) is a prestigious central government research institution focused on fostering advanced research in the fields of Materials and Polymer Science. As a PhD scholar there, my research focuses on Polymer Informatics, Materials Discovery, and Additive Manufacturing.",
    c_img:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTC4jtAmMMExzGFtyuFC5oLvzBajv_KzZEvDA&s",
    o_detail: {
      Position: "Junior Research Fellow (JRF)",
      "Employment Type": "Full Time",
    },
  },
  {
    badge: "Organization",
    title: "Atal Incubation Center - NITF",
    description:
      "AIC-Nalanda Institute of Technology Foundation is a Technology Business Incubator supported by Atal Innovation Mission, a flagship initiative set up by the NITI Aayog, Government of India to promote innovation and entrepreneurship across the nation.",
    c_img: "https://www.aicnalanda.com/public/img/aicnewlogo.png",
    o_detail: {
      Position: "Innovation Consultant",
      "Employment Type": "Consultancy",
    },
  },
  {
    badge: "Organization",
    title: "Deepchem",
    description:
      "The DeepChem project aims to make high quality open source software for scientific machine learning more accessible to scientists and developers worldwide. It has a particular focus on molecular machine learning and drug discovery, but also supports a broad range of applications in bioinformatics, materials science, and computational physics.",
    c_img: "./assets/images/deepchem.png",
    o_detail: {
      Position: "Core Code Contributor",
      "Employment Type": "Open-Source",
    },
  },
  {
    badge: "Education",
    title: "PhD in Polymer Science",
    description:
      "I am currently pursuing a PhD in Polymer Science at Utkal University, under the supervision of CIPET-IPT. My research focuses on developing, implementing, and validating computational algorithms for polymer generation.",
    c_img:
      "https://rcm.ac.in/wp-content/uploads/2023/06/Utkal-University-1.png",
    o_detail: {
      Institute: "Utkal University",
      Branch: "Polymer Science",
      Degree: "PhD",
    },
  },
  {
    break: "1",
  },
  {
    type: "time-range",
    time_text: "2024   →  2025",
  },
  {
    badge: "Organization",
    title: "Deep Forest Sciences",
    description:
      "Deep Forest Sciences specializes in developing toolkits for material discovery and related fields.",
    c_img: "./assets/images/dfs.png",
    o_detail: {
      Position: "Research Intern",
      "Employment Type": "Contractual",
    },
  },
  {
    badge: "Research Publication",
    title: "Open-source Polymer Generative Pipeline",
    description:
      "This research paper presents an open-source computational pipeline for generating hypothetical polymers with targeted properties, such as ionization potential, using neural networks and integrating it into the DeepChem framework for enhanced accessibility.",
    c_img:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bc/ArXiv_logo_2022.svg/2560px-ArXiv_logo_2022.svg.png",
    o_detail: {
      Publisher: "ArXiv",
      "Published on": "29th November, 2024",
    },
  },
  {
    badge: "Source",
    show_links: [
      {
        text: "Read Here",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bc/ArXiv_logo_2022.svg/2560px-ArXiv_logo_2022.svg.png",
        url: "https://arxiv.org/html/2412.08658v1",
      },
    ],
  },
  {
    badge: "Organization",
    title: "CIPET - SARP:LARPM",
    description:
      "The School for Advanced Research in Petrochemicals (SARP) is a prestigious central government research institution focused on fostering advanced research in the fields of Materials and Polymer Science. As a PhD scholar there, my research focuses on Polymer Informatics, Materials Discovery, and Additive Manufacturing.",
    c_img:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTC4jtAmMMExzGFtyuFC5oLvzBajv_KzZEvDA&s",
    o_detail: {
      Position: "Junior Research Fellow (JRF)",
      "Employment Type": "Full Time",
    },
  },
  {
    badge: "Organization",
    title: "Atal Incubation Center - NITF",
    description:
      "AIC-Nalanda Institute of Technology Foundation is a Technology Business Incubator supported by Atal Innovation Mission, a flagship initiative set up by the NITI Aayog, Government of India to promote innovation and entrepreneurship across the nation.",
    c_img: "https://www.aicnalanda.com/public/img/aicnewlogo.png",
    o_detail: {
      Position: "Assitant Manager (Technology)",
      "Employment Type": "Full Time",
    },
  },
  {
    badge: "Portfolio",
    id: "exp-aicnitf",
    type: "exp",
    portfolio_profile: [
      {
        title: "Vritika",
        description:
          "Developed website for an initiative for woment centric incubation program !",
        links: [
          {
            title: "website",
            image: "http://vritika.aicnitf.in/assets/img/vritika_logo.png",
            url: "http://vritika.aicnitf.in/",
          },
        ],
      },
      {
        title: "Odisha Tourism Acceleration Program",
        description:
          "Developed website for an acceleration support program specific to tourism based startups !",
        links: [
          {
            title: "OTAP Website",
            image: "https://otap.aicnitf.in/assets/img/otap_logo.png",
            url: "https://otap.aicnitf.in/",
          },
        ],
      },
      {
        title: "IPCC",
        description:
          "Managed and applied major updates for Intellectual Property Cell website.",
        links: [
          {
            title: "IPCC Website",
            image: "https://ipcc.aicnitf.in/static/assets/img/ipcc_img.png",
            url: "https://ipcc.aicnitf.in/",
          },
        ],
      },
    ],
  },
  {
    badge: "Tech Stack",
    show_links: [
      {
        image:
          "https://w7.pngwing.com/pngs/10/113/png-transparent-django-web-development-web-framework-python-software-framework-django-text-trademark-logo-thumbnail.png",
        url: "https://www.djangoproject.com/",
        text: "Django",
      },
      {
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQcR5U16C8yXgBpl7-Bc7Itjx3_LRl425zINA&s",
        url: "https://react.dev/",
        text: "React",
      },
      {
        image:
          "https://i.pinimg.com/originals/36/ca/5b/36ca5b29e647ef60e8863aa0ea75b7e0.png",
        url: "https://www.framer.com/motion/",
        text: "Framer",
      },
      {
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQco_8XiZmXl3pO2QDI7OB_M2rekPmmKJNCJQ&s",
        url: "https://cpanel.net/",
        text: "CPanel",
      },
    ],
  },
  {
    break: "1",
  },
  {
    badge: "Organization",
    title: "Deepchem (Google Summer of Code, 2024)",
    description:
      "The DeepChem project aims to make high quality open source software for scientific machine learning more accessible to scientists and developers worldwide. It has a particular focus on molecular machine learning and drug discovery, but also supports a broad range of applications in bioinformatics, materials science, and computational physics.",
    c_img: "./assets/images/deepchem.png",
    o_detail: {
      Position: "GSoC Contributor",
      "Employment Type": "Remote",
    },
  },
  {
    badge: "Portfolio",
    id: "exp-deepchem",
    type: "exp",
    portfolio_profile: [
      {
        title: "Polymer Featurizers",
        description:
          "Working on integration of weighted directed graph representation and BigSMILES representation integration into deepchem ecosystem.",
        links: [
          {
            title: "Github",
            image:
              "https://github.githubassets.com/assets/GitHub-Mark-ea2971cee799.png",
            url: "https://github.com/deepchem/deepchem",
          },
          {
            title: "Deck",
            image:
              "https://static.vecteezy.com/system/resources/previews/027/179/396/non_2x/google-slide-slides-icon-logo-symbol-free-png.png",
            url: "https://docs.google.com/presentation/d/1zQ_wzg9dHeMC_I_rWxc1RWlbD2_XfXxecSpXdNKJctU/edit?usp=sharing",
          },
          {
            title: "Forum",
            image:
              "https://forum.deepchem.io/uploads/default/original/1X/3217ffafdfcaab53ef04db5614e443498b38854d.png",
            url: "https://forum.deepchem.io/t/exploring-polymer-implementation-in-deepchem-a-gsoc-project-journey/1344",
          },
        ],
      },
      {
        title: "Educational Contributions",
        description:
          "Developing detailed tutorials for cheminformatics implications with polymer science with deepchem and RDKit",
        links: [
          {
            title: "Tutorial",
            image:
              "https://forum.deepchem.io/uploads/default/original/1X/3217ffafdfcaab53ef04db5614e443498b38854d.png",
            url: "https://deepchem.io/tutorials/an-introduction-to-the-polymers-and-their-representation/",
          },
        ],
      },
    ],
  },
  {
    badge: "Tech Stack",
    show_links: [
      {
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAgCAMAAAA2a+hwAAAAS1BMVEVHcEzvg1jwiEvyjWzwljjwiC7vfzLuiTrubk7uc1bvdznvdjXubTjuaEnuZDvuZUftYEDtXUfvaUPtWz7tZErtUkLsSkTsQEjrQU3FPKP6AAAAGXRSTlMAIDYSzv//kVtC5P//iv+j8L3S/3b////hinffsQAAAM1JREFUeAGlzUUSwzAAQ1FDwQ6YnfT+J63CzH/7RiPyPMr6+AJf77bP57tA8f029v1KsozXs2TjFbSNoF1M021MdzDdwcqyHcy2MAchuWa8MbU61Y0pJZbGGkJmidZI6Wr0YTkMTjFlKOHOz9EpLXJOeTCaeD01oZSyWjnivac20gkahQDExEhstPMhyDDOA2WxKOhk6I2kgucRz7BiNM0xC7kXOkZIVSl7hPmgY7CtlUX560z7+o/JfodEYxwU0YjQr8OGehkjCWsoyZP+K/oTxP/GSgcAAAAASUVORK5CYII=",
        url: "https://deepchem.io/",
        text: "Deepchem",
      },
      {
        image: "https://avatars.githubusercontent.com/u/2018047?s=280&v=4",
        url: "https://www.rdkit.org/",
        text: "RDKit",
      },
      {
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAjVBMVEX////6/f/t9f/D2/+bxv+kyv/O4v9/uP8Zkf9dp/9Nov8AjP+31f+w0f+oz//n8//j8f+Ovf8wlP/T6f/v9/9tsf9hrP+Uw/8Aif94uv8rkP/I4/8Af/83nv9+tP9Hpf8znP+r1P9stf9usP+Gwv+42v+rzf9hsP+hzv/Y6/+Oxf/4+v+/2P9Unf9cpP90cCeOAAAA+ElEQVR4AWIgGgB6mYsEB4EggKIfh3iajgd3vf/txg3bztuUl6KwRNV0wxx2fjPj3WZ+uFbMdy4z5MlSQLV1ZqjnowLK+sKc7VVTuN0fwPnpHRjY++sgvBtAtJaxzy/XBbmzkhQgE6Z15EceBBveFYAsj0Fc/X4Upnl/KEDpsq83SqXyoxG7UmTpLSJan1KNoYcQDxqZxffydFSYJ69sTpJ5UoRhy5RyOCCLfaa7TFTHlaOnDzBLxppQ5BcRKtBs6wdD9fqAEt0fcHA8kTGwcgC6FNpE1gEDhQDcewmmV4cpA+41PlRnuwG03mKk7Gy7f7Cg2mz2/I9XjlYR1/QXAkUAAAAASUVORK5CYII=",
        url: "https://www.dgl.ai/",
        text: "DGL",
      },
      {
        image:
          "https://raw.githubusercontent.com/pyg-team/pyg_sphinx_theme/master/pyg_sphinx_theme/static/img/pyg_logo.png",
        url: "https://pytorch-geometric.readthedocs.io/en/latest/",
        text: "Pytorch Geometric",
      },
      {
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAJFBMVEVHcEz0Ti3tSyvsSyvyTSzuTCvrSyvvTCztSyvvTCzyTSz2Ti1jX8EMAAAAC3RSTlMA61QhuW4Qgjed1ICuvi8AAADFSURBVCiRfZJZEsQgCETFBVnuf99pk5oMmHL4SAofS4OWkozL2WY9s+FHyIPOEMyllNYObIB1e6dXv9j6z7eWmxWeutdFPI3gSmBCTpNDaP9lc8+NNLqVvMfFMbl9C7NeA2Z5XwXN3LK+Rq78VNVNfX8kAW5zo9EZhkwx71umPRCCKEMJg2KUfBPq9BygqcUlNI/70+StTYdKEOBW72RGnawempx0iNSBS9h3Iop4J1pfez2FVvsCQCo7W81Qc47a/r36YB9hggYfnisLkgAAAABJRU5ErkJggg==",
        url: "https://pytorch.org/",
        text: "Pytorch",
      },
      {
        image:
          "data:image/png;base64,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",
        url: "https://aws.amazon.com/s3/",
        text: "AWS S3",
      },
      {
        image:
          "https://github.githubassets.com/assets/GitHub-Mark-ea2971cee799.png",
        url: "https://github.com",
        text: "Github",
      },
    ],
  },
  {
    break: "1",
  },
  {
    badge: "Organization",
    title: "iNeuron",
    description:
      "INeuron is a leading edtech company with primary focus on providing education on emerging technologies while making tech education easily accessible, practical and affordable.",
    c_img: "./assets/images/ineuron.png",
    o_detail: {
      Position: "Intern",
      "Employment Type": "Remote",
    },
  },
  {
    badge: "Portfolio",
    id: "exp_ineuron",
    type: "exp",
    portfolio_profile: [
      {
        title: "Large Scale QnA System with GenAI",
        description:
          "'Large Scale Question Answering System' a full-stack platform designed to address various inquiries. At its core lies a pre-trained LLM (Gemini - Pro).",
        links: [
          {
            title: "Github",
            image:
              "https://github.githubassets.com/assets/GitHub-Mark-ea2971cee799.png",
            url: "https://github.com/TRY-ER/large_scale_question_answering_system",
          },
          {
            title: "Know More",
            image: "./assets/icons/profile_logo.png",
            url: "https://try-er.github.io/debasish/#/exp-indiv/large-scale-qna",
          },
        ],
      },
    ],
  },
  {
    badge: "Tech Stack",
    show_links: [
      {
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQShzFsCcn2XFanVgk0xiEgPGicINuEgO2ADw&s",
        url: "https://www.langchain.com/",
        text: "Langchain",
      },
      {
        image:
          "https://lh3.googleusercontent.com/e5M3Bi_o8iVajobAcS0LLDDJ2RN4LzchraKjfEKWvXaTkBw2WU50kuTnF6xHzMOifL6DMe16SCUqNt5w2gB9ZA",
        url: "https://cloud.google.com/vertex-ai",
        text: "Vertex AI",
      },
      {
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcThr7qrIazsvZwJuw-uZCtLzIjaAyVW_ZrlEQ&s",
        url: "https://gemini.google.com/?hl=en-IN",
        text: "Gemini",
      },
      {
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQcR5U16C8yXgBpl7-Bc7Itjx3_LRl425zINA&s",
        url: "https://react.dev/",
        text: "React",
      },
      {
        image:
          "https://i.pinimg.com/originals/36/ca/5b/36ca5b29e647ef60e8863aa0ea75b7e0.png",
        url: "https://www.framer.com/motion/",
        text: "Framer",
      },
      {
        image:
          "https://www.softformance.com/wp-content/uploads/2022/07/1.3-FastAPI-Logo.jpg",
        url: "https://fastapi.tiangolo.com/",
        text: "FastAPI",
      },
      {
        image:
          "https://github.githubassets.com/assets/GitHub-Mark-ea2971cee799.png",
        url: "https://github.com",
        text: "Github",
      },
      {
        image:
          "https://pendulum-it.com/wp-content/uploads/2020/05/Google-Cloud-Platform-GCP-logo.png",
        url: "https://www.googleadservices.com/pagead/aclk?sa=L&ai=DChcSEwj2g4y-7cWGAxW9pmYCHcClBHAYABAAGgJzbQ&ase=2&gclid=CjwKCAjwmYCzBhA6EiwAxFwfgFEi9JEIwxAIS6oCyM2XV0hPjhXAJ6t9VHMIKRRrYOSgfsE6QaQuVhoCAxgQAvD_BwE&ohost=www.google.com&cid=CAESVeD2meyaLlFhVxwMy6oJPqMJwg7ZiYmYxy_a-anPdLJAdNVr4DPh8X-IqpMCdVgoL20zcGlMTnx-p_JPOJQ65XjrBmY2kTruHn9R3RlVCysAhuQn4SY&sig=AOD64_2EbgQi5g7G9flSHeiAb2rkShhvQQ&q&nis=4&adurl&ved=2ahUKEwjm6Ya-7cWGAxVR1jgGHd5DDoEQ0Qx6BAgGEAE",
        text: "GCP",
      },
    ],
  },
  {
    break: "1",
  },
  {
    type: "time-range",
    time_text: "2023   →  2024",
  },
  {
    badge: "Research Publication",
    title:
      "Comprehensive Machine Learning Pipeline for Prediction of Power Conversion Efficiency in Perovskite Solar Cells",
    description:
      "This research paper focuses on developement of ML pipeline, it's constraints and analysis for regression of power conversion efficiency (PCE) of Perovskite Solar Cells (PSCs).",
    c_img:
      "https://onlinelibrary.wiley.com/pb-assets/journal-banners/25130390-1583487885883.jpg",
    o_detail: {
      Publisher: "Wiley",
      Journal: "Advanced Theory and Simulations",
      "Published on": "23rd August, 2023",
    },
  },
  {
    badge: "Details",
    id: "exp-wiley-2023",
    type: "exp",
    portfolio_profile: [
      {
        title: "Data Preparation and Analysis",
        description:
          "A dataset of 42,443 data points on perovskite solar cells was meticulously cleaned and preprocessed for machine learning analysis.",
        links: [
          {
            title: "TRY-ER/PerovDataMain",
            image:
              "https://github.githubassets.com/assets/GitHub-Mark-ea2971cee799.png",
            url: "https://github.com/TRY-ER/PerovDataMain.git",
          },
        ],
      },
      {
        title: "ML Pipeline Development",
        description:
          "Various ML and DL algorithms were adopted to predict the PCE of the PSCs with crossvalidation and optimization setup.",
        links: [
          {
            title: "TRY-ER/PSC_Regressor",
            image:
              "https://github.githubassets.com/assets/GitHub-Mark-ea2971cee799.png",
            url: "https://github.com/TRY-ER/PSC_Regressor",
          },
        ],
      },
      {
        title: "Docker Deployment",
        description:
          "The deployment was done using docker-compose to integrate both frontend and backend",
        links: [
          {
            title: "Get Code",
            image:
              "https://github.githubassets.com/assets/GitHub-Mark-ea2971cee799.png",
            url: "https://github.com/TRY-ER/perov_deployment",
          },
        ],
      },
      {
        title: "Publication",
        description:
          "The findings of certain proportion of the experiment is been publshed in the given journal.",
        links: [
          {
            title: "Learn More",
            image: "./assets/icons/profile_logo.png",
            url: "https://try-er.github.io/debasish/#/project-indiv/PSC-regressor",
          },
        ],
      },
    ],
  },
  {
    badge: "Source",
    show_links: [
      {
        text: "Read Here",
        image:
          "https://onlinelibrary.wiley.com/pb-assets/hub-assets/pericles/logo-header-1690978619437.png",
        url: "https://onlinelibrary.wiley.com/doi/10.1002/adts.202300309",
      },
    ],
  },
  {
    badge: "Tech Stack",
    show_links: [
      {
        image: "https://logosandtypes.com/wp-content/uploads/2024/02/NumPy.png",
        url: "https://numpy.org/",
        text: "Numpy",
      },
      {
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRXCDD7q7wCVdRNtROzgtARnDThPmab6k2x7Q&s",
        url: "https://pandas.pydata.org/",
        text: "Pandas",
      },
      {
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRNsNsCUnCK9dU4ADTVmRc0fs0KpHJwWFNJjQ&s",
        url: "https://scikit-learn.org/",
        text: "Scikit-Learn",
      },
      {
        image:
          "https://www.intel.com/content/dam/www/central-libraries/us/en/images/2022-11/xgboost-logo-rwd.png.rendition.intel.web.480.360.png",
        url: "https://xgboost.readthedocs.io/en/stable/python/python_intro.html",
        text: "XGBoost",
      },
      {
        image: "https://avatars.githubusercontent.com/u/57251745?s=280&v=4",
        url: "https://optuna.org/",
        text: "Optuna",
      },
      {
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAJFBMVEVHcEz0Ti3tSyvsSyvyTSzuTCvrSyvvTCztSyvvTCzyTSz2Ti1jX8EMAAAAC3RSTlMA61QhuW4Qgjed1ICuvi8AAADFSURBVCiRfZJZEsQgCETFBVnuf99pk5oMmHL4SAofS4OWkozL2WY9s+FHyIPOEMyllNYObIB1e6dXv9j6z7eWmxWeutdFPI3gSmBCTpNDaP9lc8+NNLqVvMfFMbl9C7NeA2Z5XwXN3LK+Rq78VNVNfX8kAW5zo9EZhkwx71umPRCCKEMJg2KUfBPq9BygqcUlNI/70+StTYdKEOBW72RGnawempx0iNSBS9h3Iop4J1pfez2FVvsCQCo7W81Qc47a/r36YB9hggYfnisLkgAAAABJRU5ErkJggg==",
        url: "https://pytorch.org/",
        text: "Pytorch",
      },
      {
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQcR5U16C8yXgBpl7-Bc7Itjx3_LRl425zINA&s",
        url: "https://react.dev/",
        text: "React",
      },
      {
        image:
          "https://www.softformance.com/wp-content/uploads/2022/07/1.3-FastAPI-Logo.jpg",
        url: "https://fastapi.tiangolo.com/",
        text: "FastAPI",
      },
    ],
  },
  {
    break: "1",
  },
  {
    badge: "Organization",
    title: "Atal Incubation Center - NITF",
    c_img: "https://www.aicnalanda.com/public/img/aicnewlogo.png",
    o_detail: {
      Position: "Program Assistant",
      "Employment Type": "Full Time",
    },
  },
  {
    badge: "Portfolio",
    id: "exp-aicnitf-2023",
    type: "exp",
    portfolio_profile: [
      {
        title: "StartHire",
        description:
          "Developed fullstack website to connect students with startups with a matching and sorting mechanism based on jobs posted by startups. [Under Process]",
        links: [
          {
            title: "website",
            image: "./assets/images/start_hire.jpg",
            url: "https://starthire.aicnitf.in/",
          },
        ],
      },
      {
        title: "VR Development",
        description:
          "Assisted development of VR Environment with Unreal Engine, which is a approximate replica of premises of AIC-NITF. Created and managed 3D assets and environment setup, and interactions for VR implications in UE5.",
      },
      {
        title: "Additive Manufacturing",
        description:
          "Worked on various 3D product development using FDM 3D printing for various startups and organizations. Handled product development from 3D designing, printing to product post processing.",
      },
    ],
  },
  {
    badge: "Tech Stack",
    show_links: [
      {
        image:
          "https://w7.pngwing.com/pngs/10/113/png-transparent-django-web-development-web-framework-python-software-framework-django-text-trademark-logo-thumbnail.png",
        url: "https://www.djangoproject.com/",
        text: "Django",
      },
      {
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQcR5U16C8yXgBpl7-Bc7Itjx3_LRl425zINA&s",
        url: "https://react.dev/",
        text: "React",
      },
      {
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f1/Vitejs-logo.svg/2078px-Vitejs-logo.svg.png",
        url: "https://vitejs.dev/",
        text: "Vite",
      },
      {
        image:
          "https://toppng.com/uploads/preview/firebase-logo-11609361103azdpszm85x.png",
        url: "https://firebase.google.com/",
        text: "Firebase",
      },
      {
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQco_8XiZmXl3pO2QDI7OB_M2rekPmmKJNCJQ&s",
        url: "https://cpanel.net/",
        text: "CPanel",
      },
      {
        image:
          "https://w7.pngwing.com/pngs/414/62/png-transparent-blender-hd-logo-thumbnail.png",
        url: "https://www.blender.org/",
        text: "Blender",
      },
      {
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR_oVOArqhqN1Nm35c67ZIJbr7elQhF9dEvEg&s",
        url: "https://www.unrealengine.com/en-US/home",
        text: "UE5",
      },
      {
        image: "https://public-files.gumroad.com/bxcerrnm0uzqv48b3b2o2pxg4wnl",
        url: "https://makertales.gumroad.com/l/CADsketcher",
        text: "CAD-Sketcher",
      },
      {
        image:
          "data:image/png;base64,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",
        url: "https://ultimaker.com/software/ultimaker-cura/",
        text: "Cura",
      },
    ],
  },
  {
    break: "1",
  },
  {
    badge: "Organization",
    title: "iNeuron",
    description: "Enrolled in Data Science Masters program by iNeuron.",
    c_img: "./assets/images/ineuron.png",
    o_detail: {
      Position: "Student",
      Location: "Remote",
    },
  },
  {
    badge: "Portfolio",
    id: "exp-ineuron-23",
    type: "exp",
    portfolio_profile: [
      {
        title: "LC50 Value predictor",
        description:
          "This project was focused on implementing QSAR / ML algorithm to predict lethal consumption (50%) value from 6 chemical descriptors.",
        links: [
          {
            title: "Know More",
            image: "./assets/icons/profile_logo.png",
            url: "https://try-er.github.io/debasish/#/project-indiv/toxicity",
          },
        ],
      },
    ],
  },
  {
    badge: "Tech Stack",
    show_links: [
      {
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQcR5U16C8yXgBpl7-Bc7Itjx3_LRl425zINA&s",
        url: "https://react.dev/",
        text: "React",
      },
      {
        image:
          "https://www.softformance.com/wp-content/uploads/2022/07/1.3-FastAPI-Logo.jpg",
        url: "https://fastapi.tiangolo.com/",
        text: "FastAPI",
      },
      {
        image:
          "https://github.githubassets.com/assets/GitHub-Mark-ea2971cee799.png",
        url: "https://github.com",
        text: "Github",
      },
      {
        image:
          "https://cdn.iconscout.com/icon/free/png-256/free-amazon-aws-3521268-2944772.png",
        url: "https://aws.amazon.com/",
        text: "AWS",
      },
      {
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQkffNliYBPmgIshCC5WXhdL5IRG1sTa3dMOg&s",
        url: "https://aws.amazon.com/ec2/",
        text: "EC2",
      },
    ],
  },
  {
    break: "1",
  },
  {
    type: "time-range",
    time_text: "2022   →  2023",
  },
  {
    badge: "Education",
    title: "Masters in Science and Technology",
    description:
      "I completed post graduation from Central Insitute of Petrochemical Engineering and Technology in Material Science branch. The specialization that I did in my final year was in organic molecules and photovoltaics.",
    c_img:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTC4jtAmMMExzGFtyuFC5oLvzBajv_KzZEvDA&s",
    o_detail: {
      Institute: "CIPET-IPT",
      Branch: "Material Science",
      Degree: "M.(Sc).Tech",
    },
  },
  {
    break: "1",
  },
  {
    badge: "Organization",
    title: "SARP: LARPM",
    description:
      "The LARPM is a central goverment body for research and development in advance polymer domain. As my final year program, I joined the laboratory for research in stabilizing perovskite solar cells. I worked for an extended period as an intern there to continue my research journey.",
    c_img:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTC4jtAmMMExzGFtyuFC5oLvzBajv_KzZEvDA&s",
    o_detail: {
      Position: "Intern",
      "Employment Type": "Full Time",
    },
  },
  {
    badge: "Portfolio",
    id: "exp_larpm",
    type: "exp",
    portfolio_profile: [
      {
        title: "Project",
        description:
          "Stability Assessment in Metal Halide Perovskite with Incorporation of Organic Additives",
        links: [
          {
            title: "Know More",
            image: "./assets/icons/profile_logo.png",
            url: "https://try-er.github.io/debasish/#/project-indiv/stability",
          },
          {
            title: "View Final Report",
            image:
              "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQMvKZmgNZh6hd7R6xpCGskb2j5OE582uKF0w&s",
            url: "https://drive.google.com/file/d/1gujccK3Vqqj9qmm__d3ywOpngdUBGO8y/view",
          },
        ],
      },
    ],
  },
  {
    break: "1",
  },
];

export { MainTimelineSteps };
